var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link sort-container",attrs:{"type":"button"},on:{"click":_vm.onSort}},[_c('span',{staticClass:"button-text"},[_vm._t("default")],2),_vm._v(" "),_c('i',{class:_vm.orderClasses})])}
var staticRenderFns = []

export { render, staticRenderFns }